/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ImageAnalysisItemResponse } from './ImageAnalysisItemResponse';
import {
    ImageAnalysisItemResponseFromJSON,
    ImageAnalysisItemResponseFromJSONTyped,
    ImageAnalysisItemResponseToJSON,
    ImageAnalysisItemResponseToJSONTyped,
} from './ImageAnalysisItemResponse';

/**
 * Simplified Google Vision analysis surfaced to the admin sandbox + Full Throttle photo verification flow. Only populated on the CV fallback path; undefined on the LLM path (Gemini verdict isn't structured the same way).
 * @export
 * @interface ImageAnalysisDataResponse
 */
export interface ImageAnalysisDataResponse {
    /**
     * 
     * @type {Array<ImageAnalysisItemResponse>}
     * @memberof ImageAnalysisDataResponse
     */
    logos?: Array<ImageAnalysisItemResponse>;
    /**
     * 
     * @type {Array<ImageAnalysisItemResponse>}
     * @memberof ImageAnalysisDataResponse
     */
    objects?: Array<ImageAnalysisItemResponse>;
    /**
     * 
     * @type {Array<ImageAnalysisItemResponse>}
     * @memberof ImageAnalysisDataResponse
     */
    labels?: Array<ImageAnalysisItemResponse>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ImageAnalysisDataResponse
     */
    texts?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ImageAnalysisDataResponse
     */
    normalizedTexts?: Array<string>;
}

/**
 * Check if a given object implements the ImageAnalysisDataResponse interface.
 */
export function instanceOfImageAnalysisDataResponse(value: object): value is ImageAnalysisDataResponse {
    return true;
}

export function ImageAnalysisDataResponseFromJSON(json: any): ImageAnalysisDataResponse {
    return ImageAnalysisDataResponseFromJSONTyped(json, false);
}

export function ImageAnalysisDataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImageAnalysisDataResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'logos': json['logos'] == null ? undefined : ((json['logos'] as Array<any>).map(ImageAnalysisItemResponseFromJSON)),
        'objects': json['objects'] == null ? undefined : ((json['objects'] as Array<any>).map(ImageAnalysisItemResponseFromJSON)),
        'labels': json['labels'] == null ? undefined : ((json['labels'] as Array<any>).map(ImageAnalysisItemResponseFromJSON)),
        'texts': json['texts'] == null ? undefined : json['texts'],
        'normalizedTexts': json['normalizedTexts'] == null ? undefined : json['normalizedTexts'],
    };
}

export function ImageAnalysisDataResponseToJSON(json: any): ImageAnalysisDataResponse {
    return ImageAnalysisDataResponseToJSONTyped(json, false);
}

export function ImageAnalysisDataResponseToJSONTyped(value?: ImageAnalysisDataResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'logos': value['logos'] == null ? undefined : ((value['logos'] as Array<any>).map(ImageAnalysisItemResponseToJSON)),
        'objects': value['objects'] == null ? undefined : ((value['objects'] as Array<any>).map(ImageAnalysisItemResponseToJSON)),
        'labels': value['labels'] == null ? undefined : ((value['labels'] as Array<any>).map(ImageAnalysisItemResponseToJSON)),
        'texts': value['texts'],
        'normalizedTexts': value['normalizedTexts'],
    };
}

